import {
  GET_VIDEOS,
  GET_VIDEO,
  UPDATE_VIDEO,
  CREATE_VIDEO,
  SET_ALL_VIDEOS,
  SET_ALL_VIDEO_SELECT
} from "../../reducerTypes";

const initialState = {
  getData: {},
  getList: [],
  selectData: [],
};

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_VIDEOS:
      return {
        //...state,
        getList: action.payload,
      };
    case GET_VIDEOS:
      return {
        ...state,
        getList: action.payload,
      };
    case SET_ALL_VIDEO_SELECT:
      const contentData = action.payload ? action.payload : [];
      const selectData = [];
      contentData.map((data) => {
        selectData.push({
          value: data.id,
          label: `${data.title}`,
          price: data.price,
        });
      });
      return {
        ...state,
        selectData: selectData,
      };
    case CREATE_VIDEO:
      return {
        ...state,
        getData: action.payload,
      };
    case GET_VIDEO:
      return {
        ...state,
        getData: action.payload,
      };
    case UPDATE_VIDEO:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default subscriptionReducer;
